var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-row justify-center"},[_c('div',{attrs:{"id":"qrcode"}},[(_vm.event)?_c('QrcodeVue',{ref:"qrCodeUrl",attrs:{"value":_vm.url,"size":"160","renderAs":"canvas","level":"H"}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }